<template>
    <UIGridContainer>
        <h2 class="text-center mb-4 title">{{ translate('aboutinsta.connect') }}</h2>
        <div>
            <UIGridRow class="flex-nowrap justify-content-center d-none d-lg-flex mr-0 ml-0">
                <AboutInstagramPost :size="'large'" :post="posts[0]" />
                <div class="small">
                    <AboutInstagramPost :post="posts[1]" />
                    <AboutInstagramPost :post="posts[2]" />
                </div>
                <AboutInstagramPost :size="'large'" :post="posts[3]" />
            </UIGridRow>

            <UIGridRow class="flex-nowrap justify-content-md-center ml-lg-0 social-feed-bottom">
                <div class="small mobile-adjust">
                    <AboutInstagramPost :post="posts[4]" />
                    <AboutInstagramPost :post="posts[5]" />
                    <AboutInstagramPost class="d-lg-none" :post="posts[6]" />
                </div>
                <AboutInstagramPost class="d-none d-lg-block" :size="'large'" :post="posts[7]" />
                <div class="small">
                    <AboutInstagramPost :post="posts[8]" />
                    <AboutInstagramPost :post="posts[9]" />
                    <AboutInstagramPost class="d-lg-none" :post="posts[10]" />
                </div>
                <div class="small">
                    <AboutInstagramPost :post="posts[11]" />
                    <AboutInstagramPost :post="posts[12]" />
                    <AboutInstagramPost class="d-lg-none" :post="posts[13]" />
                </div>
            </UIGridRow>
        </div>
    </UIGridContainer>
</template>

<script>
import { UIGridContainer, UIGridRow } from '@dundle/ui/components';
import { AboutInstagramPost } from '~/components/about';
import TranslationMixin from '~/mixins/TranslationMixin';
export default {
    components: {
        UIGridRow,
        UIGridContainer,
        AboutInstagramPost,
    },
    mixins: [TranslationMixin],
    props: {
        posts: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.social-feed-bottom {
    @media screen and (min-width: 992px) {
        width: 100%;
    }

    @media screen and (max-width: 320px) {
        width: auto;
    }
}

.mobile-adjust {
    @media screen and (max-width: 992px) {
        margin-left: 1px;
    }
}

.small:first-of-type {
    @media (min-width: 576px) and (max-width: 768px) {
        margin-left: 0;
    }
}

.title {
    margin-top: 4rem;
    font-size: 1.8rem;
    line-height: 1.533rem;
    color: $color-primary-dark;

    @media screen and (min-width: 768px) {
        margin-top: 7.6rem;
    }
}
</style>
<i18n></i18n>
